export function containImageRect(container, naturalWidth, naturalHeight) {
  const cw = Number(container?.width) || 0
  const ch = Number(container?.height) || 0
  const nw = Number(naturalWidth) || 0
  const nh = Number(naturalHeight) || 0
  if (!cw || !ch || !nw || !nh) {
    return { left: 0, top: 0, width: cw, height: ch }
  }
  const scale = Math.min(cw / nw, ch / nh)
  const width = nw * scale
  const height = nh * scale
  return {
    left: (cw - width) / 2,
    top: (ch - height) / 2,
    width,
    height,
  }
}

export function clientToImageNorm(clientX, clientY, containerRect, imageRect) {
  const width = imageRect?.width || 0
  const height = imageRect?.height || 0
  if (!width || !height) return { x: 0, y: 0 }
  const originX = (containerRect?.left || 0) + (imageRect.left || 0)
  const originY = (containerRect?.top || 0) + (imageRect.top || 0)
  return {
    x: Math.min(1, Math.max(0, (clientX - originX) / width)),
    y: Math.min(1, Math.max(0, (clientY - originY) / height)),
  }
}

export function normalizeCropBox(box) {
  const rawW = Number(box?.width)
  const rawH = Number(box?.height)
  if (!Number.isFinite(rawW) || !Number.isFinite(rawH) || rawW <= 0 || rawH <= 0) {
    return { x: 0, y: 0, width: 1, height: 1 }
  }
  const width = Math.min(1, Math.max(0, rawW))
  const height = Math.min(1, Math.max(0, rawH))
  if (width * height < 0.0001) {
    return { x: 0, y: 0, width: 1, height: 1 }
  }
  const x = Math.min(1 - width, Math.max(0, Number(box?.x) || 0))
  const y = Math.min(1 - height, Math.max(0, Number(box?.y) || 0))
  return { x, y, width, height }
}
